// REACT
import React, {Component} from 'react';

// STYLES
import styled from 'styled-components';

// COMPONENTS
import Lightbox from 'react-image-lightbox';

export default class Gallery extends Component {
    constructor(){
        super();
        this.state = {isOpen: false, photoIndex: 0};
    }
    render() {
        const {
            t,
            media
        } = this.props;

        const {
            isOpen,
            photoIndex
        } = this.state;
    
        let images = []
        media.forEach(value => {
            images.push(value.path)
        });
        
        return (
            <GalleryContent onClick={() => this.setState({ isOpen: true })}>
                <Image style={{backgroundImage:"url("+ media[0].path + ")"}}>
                <BtnGallery>{t('VER GALERIA')}</BtnGallery>
                    {
                        isOpen && 
                            <Lightbox
                                mainSrc={images[photoIndex]}
                                nextSrc={images[(photoIndex + 1) % images.length]}
                                prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                                onCloseRequest={() => this.setState({ isOpen: false })}
                                onMovePrevRequest={() => this.setState({
                                    photoIndex: (photoIndex + images.length - 1) % images.length,
                                })}
                                onMoveNextRequest={() => this.setState({
                                    photoIndex: (photoIndex + 1) % images.length,
                                })}
                                ariaHideApp={false}
                            />
                    }
                </Image>
            </GalleryContent>
        )
    }
}

const GalleryContent = styled.div `
    width: 100%;
    height: 360px;
    margin-top:30px;
    position:relative;
    cursor: pointer;
    box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.150);
    border-radius: 3px;

    @media screen and (max-width: 991px) {
        width: 100%;
    } 
`
const Image = styled.div `
    width: 100%;
    height: 360px;
    background-color: #666666;
    background-size: cover;
    background-position: fixed;
    background-repeat: no-repeat;
    border-radius: 3px;
`
const BtnGallery = styled.div `
    width: 100%;
    height: 70px;
    text-align: center; 
    line-height: 70px;
    color: #FFF; 
    font-size: 18px;
    font-weight: bold;
    background-color: rgba(0,0,0,0.5);
    position: absolute;
    bottom: 0;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: "PT Sans";
    border-bottom-left-radius:3px;
    border-bottom-right-radius:3px;

    &:hover{
        background-color: rgba(0,0,0,0.7);
    }
`




// WEBPACK FOOTER //
// ./src/containers/Gallery/gallery.container.js